/**
 * Wholesale signup — Typeform-style multi-step wizard over a single Shopify
 * contact form. Progressive enhancement: without JS all steps are visible and
 * native validation works; with JS it becomes a 3-step flow.
 */
(function () {
  'use strict';

  const init = (form) => {
    if (!form || form.dataset.wholesaleInit) return;
    form.dataset.wholesaleInit = '1';

    // Post-submit: Shopify redirects to ?contact_posted=true. Reveal the
    // confirmation and hide the form fields. The success block is always in the
    // DOM (hidden until success), so this also recovers the confirmation if an
    // edge cache serves a stale render where form.posted_successfully? was false.
    const successEl = form.querySelector('[data-wholesale-success]');
    if (successEl && location.search.indexOf('contact_posted=true') !== -1) {
      successEl.hidden = false;
      form.querySelectorAll('.iurop-wholesale__progress, .iurop-wholesale__steps, .iurop-wholesale__nav, .iurop-wholesale__error-note, .iurop-wholesale__errors')
        .forEach((el) => { el.hidden = true; });
      try { successEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
      return;
    }

    const steps = Array.from(form.querySelectorAll('[data-step]'));
    if (steps.length < 2) return;

    const backBtn = form.querySelector('[data-wholesale-back]');
    const nextBtn = form.querySelector('[data-wholesale-next]');
    const submitBtn = form.querySelector('[data-wholesale-submit]');
    const fill = form.querySelector('[data-wholesale-fill]');
    const counter = form.querySelector('[data-wholesale-counter]');
    const stepTitle = form.querySelector('[data-wholesale-step-title]');
    const titles = steps.map((s) => s.getAttribute('data-title') || '');
    let current = 0;

    // Enhance: hide non-active steps via CSS, and disable native validation on
    // hidden fields (which would otherwise throw "not focusable" on submit).
    form.classList.add('is-enhanced');
    form.noValidate = true;

    const render = (focus) => {
      const last = current === steps.length - 1;
      steps.forEach((s, i) => s.classList.toggle('is-active', i === current));
      if (backBtn) backBtn.hidden = current === 0;
      if (nextBtn) nextBtn.hidden = last;
      if (submitBtn) submitBtn.hidden = !last;
      if (fill) fill.style.width = (((current + 1) / steps.length) * 100) + '%';
      if (counter) counter.textContent = 'Paso ' + (current + 1) + ' de ' + steps.length;
      if (stepTitle) stepTitle.textContent = titles[current];
      if (focus) {
        const f = steps[current].querySelector('input, select, textarea');
        if (f) { try { f.focus({ preventScroll: true }); } catch (_) { f.focus(); } }
      }
    };

    const firstInvalid = (stepIndex) => {
      const fields = steps[stepIndex].querySelectorAll('input, select, textarea');
      for (let i = 0; i < fields.length; i++) {
        if (!fields[i].checkValidity()) return fields[i];
      }
      return null;
    };

    const goNext = () => {
      const bad = firstInvalid(current);
      if (bad) { bad.reportValidity(); return; }
      if (current < steps.length - 1) { current += 1; render(true); }
    };

    const goBack = () => {
      if (current > 0) { current -= 1; render(true); }
    };

    if (nextBtn) nextBtn.addEventListener('click', goNext);
    if (backBtn) backBtn.addEventListener('click', goBack);

    // Enter advances (typeform feel) on non-last steps; never inside a textarea.
    form.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' || e.target.tagName === 'TEXTAREA') return;
      if (current < steps.length - 1) { e.preventDefault(); goNext(); }
    });

    const errorNote = form.querySelector('[data-wholesale-error]');

    // Final submit: validate every step client-side, then let the form submit
    // NATIVELY. The store has Google reCAPTCHA on the contact form (visible in
    // the console as api.js?render=explicit). Shopify's spam protection
    // intercepts the REAL submit, runs reCAPTCHA, attaches the token, then posts
    // and redirects to ?contact_posted=true — where the section renders the
    // success message server-side (form.posted_successfully?).
    //
    // The previous version AJAX-submitted with fetch(), which bypassed
    // reCAPTCHA: no token was attached, so Shopify replied HTTP 400 and the user
    // always saw a false "no se pudo enviar" error while the merchant received
    // nothing. Never re-introduce an AJAX submit while reCAPTCHA is enabled.
    form.addEventListener('submit', (e) => {
      for (let i = 0; i < steps.length; i++) {
        const bad = firstInvalid(i);
        if (bad) {
          e.preventDefault();
          current = i;
          render(false);
          bad.reportValidity();
          return;
        }
      }
      // All steps valid → do NOT preventDefault. reCAPTCHA needs the native
      // submit to proceed. Give feedback but don't disable the button, which
      // could interfere with reCAPTCHA's async re-submit.
      if (errorNote) errorNote.hidden = true;
      if (submitBtn && !submitBtn.dataset.label) {
        submitBtn.dataset.label = submitBtn.textContent;
        submitBtn.textContent = 'Enviando…';
      }
    });

    render(false);
  };

  const boot = (root) => (root || document).querySelectorAll('.iurop-wholesale__form').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
